export default async (to) => {
  const route = to;
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$store;

  if (/^(\/login|\/forgot-password|\/reset-password|\/verify-otp|\/form).*/gi.test(route.path)) {
    return null;
  }

  let authorized = true;

  const metaKey = route.matched.map((item) => item.meta) || route?.meta || [];
  const routeMetaArray = Array.isArray(metaKey) ? metaKey : [metaKey];
  const routeMeta = routeMetaArray.filter((meta) => {
    try {
      return meta?.auth?.accessKeys;
    } catch (err) {
      return false;
    }
  });

  const checkForSubstring = !!routeMetaArray.filter((meta) => meta.auth && meta.auth.checkSubstring).length;

  if (routeMeta.length === 0) return null;

  if (!store.getters.userAreas) {
    try {
      await store.dispatch('user-login/userDetails');
    } catch (err) {
      return navigateTo('/not-authorized');
    }
  }

  for (let meta of routeMeta) {
    authorized = store.getters.hasAccess(meta.auth.accessKeys, checkForSubstring);
    if (authorized) break;
  }

  const destinationRoute = routeMeta.length ? routeMeta[routeMeta.length - 1] : {};

  if (authorized && destinationRoute.defaultChild) {
    return navigateTo(`${route.fullPath}/${destinationRoute.defaultChild}`);
  }

  return !authorized ? navigateTo('/not-authorized') : null;
};
